import { McpConnectionCard } from '@/features/apps/components/McpConnectionCard';

const PREVIEW_SETTINGS = {
  enabled: true,
  endpoint_created_at: '2026-08-16T12:00:00.000Z',
  disabled_reason: null,
};

export default function McpCardStatePreview() {
  return (
    <div className="min-h-screen bg-slate-100 p-6 space-y-8">
      <h1 className="text-lg font-semibold">MCP card states — render proof (not an app seat)</h1>
      <section data-testid="preview-fresh" className="max-w-xl space-y-2">
        <h2 className="text-sm font-medium">1. Fresh key just minted</h2>
        <McpConnectionCard
          appId="app_preview_rmf"
          appName="ROTATE_MINT_FIRST preview"
          mcpSettings={PREVIEW_SETTINGS}
          mcpKeyId="key_preview_new"
          previewState="fresh"
        />
      </section>
      <section data-testid="preview-previous-active" className="max-w-xl space-y-2">
        <h2 className="text-sm font-medium">2. Previous key still active</h2>
        <McpConnectionCard
          appId="app_preview_rmf"
          appName="ROTATE_MINT_FIRST preview"
          mcpSettings={PREVIEW_SETTINGS}
          mcpKeyId="key_preview_new"
          previewState="previous-active"
        />
      </section>
      <section data-testid="preview-after-revoke" className="max-w-xl space-y-2">
        <h2 className="text-sm font-medium">3. After deliberate revoke</h2>
        <McpConnectionCard
          appId="app_preview_rmf"
          appName="ROTATE_MINT_FIRST preview"
          mcpSettings={PREVIEW_SETTINGS}
          mcpKeyId="key_preview_new"
          previewState="after-revoke"
        />
      </section>
    </div>
  );
}
